import { render, staticRenderFns } from "./TransferWarrantyStockItem.vue?vue&type=template&id=f33b972c&scoped=true"
import script from "./TransferWarrantyStockItem.vue?vue&type=script&lang=js"
export * from "./TransferWarrantyStockItem.vue?vue&type=script&lang=js"
import style0 from "./TransferWarrantyStockItem.vue?vue&type=style&index=0&id=f33b972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33b972c",
  null
  
)

export default component.exports